import './config/sentry.ts'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from 'config/api'
import 'hooks/settings'
import { AuthenticationContextProvider } from './components/core/AuthContext.tsx'
import { Entrypoint } from './components/core/Entrypoint.tsx'
import './index.css'
import { startDarkModeWatcher } from 'util/darkMode.ts'
import { startFirestoreDocTracker } from 'util/firestore/counter.ts'
import './util/wdio.helpers'
import {
  installEnvironmentBackground,
  isProdOrBeta,
} from 'config/environment.ts'
import { startFetchWrapper } from 'util/fetchWrapper.ts'
import { startDocumentCounter } from '@breakoutlearning/firebase-repository/firestore-mobx'
import { captureVitePreloadError } from 'util/vitePreloadError.ts'
import { audioContextCensus } from '@breakoutlearning/firebase-repository/util/audioContextCensus'

// Before anything renders, so every AudioContext the page builds, including
// livekit's, goes through the counting constructor.
audioContextCensus.install(window)

startDarkModeWatcher()

startFetchWrapper()

// Start Firestore document tracker and document counter in non-prod envs
if (!isProdOrBeta()) {
  startFirestoreDocTracker()
  startDocumentCounter()
}

installEnvironmentBackground()

// This is a handler for a situation where the app is running, it's requesting
// a new chunk, but we've deployed a new version of the app and that chunk is
// not available. Since now we store old chunks, this should not happen,
// however, network errors or other unexpected issues could still occur.
//
// Which is why we capture the exception with Sentry to monitor these occurrences.
//
window.addEventListener('vite:preloadError', captureVitePreloadError)

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <AuthenticationContextProvider>
      <Entrypoint />
    </AuthenticationContextProvider>
  </QueryClientProvider>
)
